
import { Product, BlogPost } from '../types';
import { productQueries } from '../../data/products';
import { contentRepository } from '../../data/contentRepository';
import { SEARCH } from '../constants/search';

export const searchService = {
    /**
     * Searches products.
     * Future Integration: Algolia / ElasticSearch / Typesense
     */
    async searchProducts(query: string): Promise<Product[]> {
        // Simulate network latency of an external search engine
        await new Promise(resolve => setTimeout(resolve, SEARCH.SIMULATED_LATENCY_MS));
        
        const { products: allProducts } = await productQueries.getAllProducts(null, SEARCH.MAX_RESULTS_PRODUCTS);
        const lowerQ = query.toLowerCase();
        
        return allProducts.filter(p =>
            p.title.toLowerCase().includes(lowerQ) ||
            p.category.toLowerCase().includes(lowerQ) ||
            p.keywords?.some(k => k.toLowerCase().includes(lowerQ))
        );
    },

    /**
     * Searches blog posts.
     */
    async searchBlogPosts(query: string): Promise<BlogPost[]> {
        if (!query || query.length < 2) return [];
        const lowerQ = query.toLowerCase();

        const { posts: allPosts } = await contentRepository.getAllPosts(null, SEARCH.MAX_RESULTS_BLOG, 'active');

        return allPosts.filter(p => 
            p.title.toLowerCase().includes(lowerQ) ||
            p.content.toLowerCase().includes(lowerQ) ||
            p.tags.some(t => t.toLowerCase().includes(lowerQ))
        ).slice(0, SEARCH.RESULTS_LIMIT);
    }
};
